export enum Event {
  Signin = 'sign-in',
  PageLoad = 'page-load',
}
